import * as actionType from "./constants";

const initialState = {
    getprojectsInMasterDropdownData: {},
    clearTaskResponse: {},
    updateEndTaskManagerResponse: {},
    deleteTaskManagerByIdResponse: {},
    getTaskManagerResponse: {
        isLoading: false
    },
    getSmartChartLogResponse: {
        loading: false
    },
    exportSmartChartDataResponse: {},
    masterFilterList: {
        project: {},
        energy_mng: {},
        documents: {}
    },
    saveSmartChartDataResponse: {},
    exportedSmartChartListResponse: {},
    deleteSmartChartReportResponse: {},
    uploadDocForSmartChartResponse: null,
    uploadedDocListResponse: {},
    updateSmartChartDataResponse: {},
    getTemplatePropertiesListResponse: {},
    getTemplateListResponse: {},
    getClientDropDownDataResponse: {},
    userDocOrderChangeResponse: {},
    deleteUserDocResponse: {},
    getSmartChartPropertiesListResponse: {},
    activeLastVisitedReport: {},
    getSmartChartPropertyByIdResponse: {},
    uploadedImageListResponse: {},
    saveAndExportSmartChartDataResponse: {},
    deleteSmartChartReportTemplateResponse: {},
    reportsByTemplateListResponse: {},
    lockSmartChartTemplateResponse: {},
    getCAbandDropdownData: {},
    getCAbandTradeDropdownData: {},
    getUserByClientData: {},
    exportTemplateList: {},
    exportPropertyList: {},
    exportSettingsData: {},
    saveExportSettingsData: {},
    mFilters: {},
    taskManagerTableFilterResponse: {},
    getCAbandSystemDropdownData: {},
    allExportSettingsData: {},
    updateCoreReportDataResponse: {},
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            active: true
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        },
        selectedDropdown: "active",
        sortParams: {
            sort_by: "created_date",
            order: "desc"
        },
        filterKey: "",
        exportby_user_ids: []
    },
    propertyEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            active: true
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        },
        selectedDropdown: "active",
        sortParams: {
            sort_by: "created_date",
            order: "desc"
        },
        filterKey: "",
        exportby_user_ids: []
    },
    coreReportEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            active: true
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        },
        selectedDropdown: "active",
        sortParams: {
            sort_by: "created_date",
            order: "desc"
        },
        filterKey: "",
        exportby_user_ids: []
    },
    docOrImageEntityParams: {
        documents: {},
        images: {}
    },
    getSourceTemplate: {},
    caColumns: {},
    AssetExportSettingsData: {},
    exportAssetPropertyList: {},
    exportAssetTemplateList: {},
    saveAssetExportSettingsData: {},
    getBuildingTradeData: {},
    getAsposeStatus: {},
    getSiteTradeData: {},
    getDefaultYearBreakdownResponse: {},
    patchYearBreakdownProperty: {},
    getDocumentPreviewResponse: {},
    getDefaultBbiProperty: {},
    getDefaultBsiProperty: {},
    updateDocForSmartChartResponse: null,
    exportCoreReportDataResponse: {},
    coreReportCreateDataResponse: {},
    getHeaderKeyListResponse: { loading: false },
    getExecutiveSummaryBandTilesResponse: { loading: false },
    saveExecutiveSummaryTileToBuildingResponse: { loading: false }
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_MASTER_FILTER_IN_SMART_CHART_REQUEST:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.entity]: {
                        ...state.masterFilterList[action.entity],
                        [action.filterKey]: [],
                        loading: true
                    }
                }
            };

        case actionType.GET_MASTER_FILTER_IN_SMART_CHART_SUCCESS:
            let dropDownData = [];

            if (
                action.filterKey === "fmp" ||
                action.filterKey === "infrastructure_requests" ||
                action.filterKey === "fci" ||
                action.filterKey === "building_use" ||
                action.filterKey === "secondary_use" ||
                action.filterKey === "sectors" ||
                action.filterKey === "internal_groups" ||
                action.filterKey === "division"
            ) {
                dropDownData = action.response?.data?.map(data => ({
                    id: data.name,
                    name: data.name,
                    count: data.count
                }));
            } else {
                dropDownData = [...action.response?.data];
            }

            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.entity]: {
                        ...state.masterFilterList[action.entity],
                        [action.filterKey]: dropDownData,
                        loading: false
                    }
                }
            };

        case actionType.GET_MASTER_FILTER_IN_SMART_CHART_FAILURE:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.entity]: {
                        ...state.masterFilterList[action.entity],
                        [action.filterKey]: [],
                        loading: false
                    }
                }
            };

        case actionType.EXPORT_SMART_CHART_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.EXPORT_SMART_CHART_DATA_SUCCESS:
            return {
                ...state,
                exportSmartChartDataResponse: { success: true, ...action.response }
            };
        case actionType.EXPORT_SMART_CHART_DATA_FAILURE:
            return {
                ...state,
                exportSmartChartDataResponse: { success: false, ...action.error }
            };
        case actionType.SAVE_SMART_CHART_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.SAVE_SMART_CHART_DATA_SUCCESS:
            return {
                ...state,
                saveSmartChartDataResponse: { success: true, ...action.response }
            };
        case actionType.SAVE_SMART_CHART_DATA_FAILURE:
            return {
                ...state,
                saveSmartChartDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_EXPORTED_SMART_CHART_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORTED_SMART_CHART_LIST_SUCCESS:
            return {
                ...state,
                exportedSmartChartListResponse: { success: true, ...action.response }
            };
        case actionType.GET_EXPORTED_SMART_CHART_LIST_FAILURE:
            return {
                ...state,
                exportedSmartChartListResponse: { success: false, ...action.error }
            };
        case actionType.DELETE_SMART_CHART_REPORT_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_SMART_CHART_REPORT_SUCCESS:
            return {
                ...state,
                deleteSmartChartReportResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_SMART_CHART_REPORT_FAILURE:
            return {
                ...state,
                deleteSmartChartReportResponse: { success: false, ...action.error }
            };
        case actionType.UPLOAD_DOC_FOR_SMART_REPORT_REQUEST:
            return {
                ...state,
                uploadDocForSmartChartResponse: null
            };
        case actionType.UPLOAD_DOC_FOR_SMART_REPORT_SUCCESS:
            return {
                ...state,
                uploadDocForSmartChartResponse: { success: true, ...action.response }
            };
        case actionType.UPLOAD_DOC_FOR_SMART_REPORT_FAILURE:
            return {
                ...state,
                uploadDocForSmartChartResponse: { success: false, ...action.error }
            };
        case actionType.GET_UPLOADED_DOC_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_UPLOADED_DOC_LIST_SUCCESS:
            return {
                ...state,
                uploadedDocListResponse: { success: true, ...action.response }
            };
        case actionType.GET_UPLOADED_DOC_LIST_FAILURE:
            return {
                ...state,
                uploadedDocListResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_SMART_REPORT_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_SMART_REPORT_DATA_SUCCESS:
            return {
                ...state,
                updateSmartChartDataResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_SMART_REPORT_DATA_FAILURE:
            return {
                ...state,
                updateSmartChartDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_TEMPLATE_PROPERTIES_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_TEMPLATE_PROPERTIES_LIST_SUCCESS:
            let propertyList = [...action.response?.data];
            return {
                ...state,
                getTemplatePropertiesListResponse: { success: true, data: [...propertyList] }
            };
        case actionType.GET_TEMPLATE_PROPERTIES_LIST_FAILURE:
            return {
                ...state,
                getTemplatePropertiesListResponse: { success: false, ...action.error }
            };
        case actionType.GET_TEMPLATE_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_TEMPLATE_LIST_SUCCESS:
            let templateList = [...action.response?.data];
            return {
                ...state,
                getTemplateListResponse: { success: true, data: [...templateList] }
            };
        case actionType.GET_TEMPLATE_LIST_FAILURE:
            return {
                ...state,
                getTemplateListResponse: { success: false, ...action.error }
            };
        case actionType.GET_CLIENTS_LIST_FOR_SMART_CHART_REQUEST:
            return {
                ...state
            };
        case actionType.GET_CLIENTS_LIST_FOR_SMART_CHART_SUCCESS:
            return {
                ...state,
                getClientDropDownDataResponse: { success: true, ...action.response }
            };
        case actionType.GET_CLIENTS_LIST_FOR_SMART_CHART_FAILURE:
            return {
                ...state,
                getClientDropDownDataResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_DOC_ORDER_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_DOC_ORDER_SUCCESS:
            return {
                ...state,
                userDocOrderChangeResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_DOC_ORDER_FAILURE:
            return {
                ...state,
                userDocOrderChangeResponse: { success: false, ...action.error }
            };
        case actionType.DELETE_USER_DOC_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_USER_DOC_SUCCESS:
            return {
                ...state,
                deleteUserDocResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_USER_DOC_FAILURE:
            return {
                ...state,
                deleteUserDocResponse: { success: false, ...action.error }
            };
        case actionType.GET_SMART_CHART_PROPERTIES_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_SMART_CHART_PROPERTIES_LIST_SUCCESS:
            return {
                ...state,
                getSmartChartPropertiesListResponse: { success: true, ...action.response }
            };
        case actionType.GET_SMART_CHART_PROPERTIES_LIST_FAILURE:
            return {
                ...state,
                getSmartChartPropertiesListResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_SMART_CHART_PROPERTY_SUCCESS:
            return {
                ...state,
                saveSmartChartDataResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_SMART_CHART_PROPERTY_FAILURE:
            return {
                ...state,
                saveSmartChartDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_SMART_CHART_PROPERTY_BY_ID_REQUEST:
            return {
                ...state
            };
        case actionType.GET_SMART_CHART_PROPERTY_BY_ID_SUCCESS:
            return {
                ...state,
                getSmartChartPropertyByIdResponse: { success: true, data: { ...action.response } }
            };
        case actionType.GET_SMART_CHART_PROPERTY_BY_ID_FAILURE:
            return {
                ...state,
                getSmartChartPropertyByIdResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_SMART_REPORT_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                mFilters: { ...action.mFilters },
                entityParams: { ...state.entityParams, ...action.entityParams }
            };
        case actionType.GET_UPLOADED_IMAGE_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_UPLOADED_IMAGE_LIST_SUCCESS:
            return {
                ...state,
                uploadedImageListResponse: { success: true, ...action.response }
            };
        case actionType.GET_UPLOADED_IMAGE_LIST_FAILURE:
            return {
                ...state,
                uploadedImageListResponse: { success: false, ...action.error }
            };
        case actionType.SAVE_AND_EXPORT_SMART_CHART_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.SAVE_AND_EXPORT_SMART_CHART_DATA_SUCCESS:
            return {
                ...state,
                saveAndExportSmartChartDataResponse: { success: true, ...action.response }
            };
        case actionType.SAVE_AND_EXPORT_SMART_CHART_DATA_FAILURE:
            return {
                ...state,
                saveAndExportSmartChartDataResponse: { success: false, ...action.error }
            };
        case actionType.DELETE_SMART_CHART_REPORT_TEMPLATE_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_SMART_CHART_REPORT_TEMPLATE_SUCCESS:
            return {
                ...state,
                deleteSmartChartReportTemplateResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_SMART_CHART_REPORT_TEMPLATE_FAILURE:
            return {
                ...state,
                deleteSmartChartReportTemplateResponse: { success: false, ...action.error }
            };
        case actionType.GET_REPORTS_BY_TEMPLATE_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_REPORTS_BY_TEMPLATE_LIST_SUCCESS:
            return {
                ...state,
                reportsByTemplateListResponse: { success: true, ...action.response }
            };
        case actionType.GET_REPORTS_BY_TEMPLATE_LIST_FAILURE:
            return {
                ...state,
                reportsByTemplateListResponse: { success: false, ...action.error }
            };
        case actionType.LOCK_SMART_CHART_TEMPLATE_REQUEST:
            return {
                ...state
            };
        case actionType.LOCK_SMART_CHART_TEMPLATE_SUCCESS:
            return {
                ...state,
                lockSmartChartTemplateResponse: { success: true, ...action.response }
            };
        case actionType.LOCK_SMART_CHART_TEMPLATE_FAILURE:
            return {
                ...state,
                lockSmartChartTemplateResponse: { success: false, ...action.error }
            };
        case actionType.GET_CA_BAND_FILTER_DROPDOWN_DATA_REQUEST:
            return {
                ...state,
                getCAbandDropdownData: { loading: true }
            };
        case actionType.GET_CA_BAND_FILTER_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                getCAbandDropdownData: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_CA_BAND_FILTER_DROPDOWN_DATA_FAILURE:
            return {
                ...state,
                getCAbandDropdownData: { loading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_ENTITY_FILTER_PARAMS_SMART_CHARTS:
            return {
                ...state,
                docOrImageEntityParams: { ...state.docOrImageEntityParams, [action.key]: { ...action.filterParams } }
            };
        case actionType.CLEAR_SMART_CHART_REDUCER_DATA:
            return {
                ...state,
                masterFilterList: {
                    project: {},
                    energy_mng: {},
                    documents: {}
                }
            };
        case actionType.GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                getCAbandTradeDropdownData: { success: true, ...action.response }
            };
        case actionType.GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_FAILURE:
            return {
                ...state,
                getCAbandTradeDropdownData: { success: false, ...action.error }
            };
        case actionType.UPDATE_SMART_REPORT_TEMPLATE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                ...(action.reportType === "core-report"
                    ? {
                          coreReportEntityParams: { ...state.coreReportEntityParams, ...action.entityParams }
                      }
                    : {
                          propertyEntityParams: { ...state.propertyEntityParams, ...action.entityParams }
                      })
            };
        case actionType.RESET_SMART_REPORT_TEMPLATE_ENTITY_PARAMS:
            return {
                ...state,
                coreReportEntityParams: initialState.coreReportEntityParams,
                propertyEntityParams: initialState.propertyEntityParams,
                entityParams: initialState.entityParams
            };
        case actionType.GET_USERS_BY_CLIENT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_USERS_BY_CLIENT_SUCCESS:
            return {
                ...state,
                getUserByClientData: { success: true, ...action.response }
            };
        case actionType.GET_USERS_BY_CLIENT_FAILURE:
            return {
                ...state,
                getUserByClientData: { success: false, ...action.error }
            };
        case actionType.CLEAR_USER_BY_CLIENT_DATA:
            return {
                ...state,
                getUserByClientData: {}
            };
        case actionType.GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_SUCCESS:
            return {
                ...state,
                exportPropertyList: { success: true, ...action.response }
            };
        case actionType.GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_FAILURE:
            return {
                ...state,
                exportPropertyList: { success: false, ...action.error }
            };
        case actionType.GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_SUCCESS:
            return {
                ...state,
                exportTemplateList: { success: true, ...action.response }
            };
        case actionType.GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_FAILURE:
            return {
                ...state,
                exportTemplateList: { success: false, ...action.error }
            };
        case actionType.GET_EXPORT_SETTINGS_NORMAL_RECOM_REQUEST:
            return {
                ...state,
                exportSettingsData: { loading: true }
            };
        case actionType.GET_EXPORT_SETTINGS_NORMAL_RECOM_SUCCESS:
            return {
                ...state,
                exportSettingsData: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_EXPORT_SETTINGS_NORMAL_RECOM_FAILURE:
            return {
                ...state,
                exportSettingsData: { loading: false, success: false, ...action.error }
            };
        case actionType.ADD_EXPORT_SETTINGS_NORMAL_RECOM_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_EXPORT_SETTINGS_NORMAL_RECOM_SUCCESS:
            return {
                ...state,
                saveExportSettingsData: { success: true, ...action.response }
            };
        case actionType.ADD_EXPORT_SETTINGS_NORMAL_RECOM_FAILURE:
            return {
                ...state,
                saveExportSettingsData: { success: false, ...action.error }
            };
        case actionType.CLEAR_PROPERTY_BY_ID_DATA:
            return {
                ...state,
                getSmartChartPropertyByIdResponse: {}
            };
        case actionType.GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                getCAbandSystemDropdownData: { success: true, ...action.response }
            };
        case actionType.GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_FAILURE:
            return {
                ...state,
                getCAbandSystemDropdownData: { success: false, ...action.error }
            };
        case actionType.GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_SUCCESS:
            return {
                ...state,
                allExportSettingsData: { success: true, ...action.response }
            };
        case actionType.GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_FAILURE:
            return {
                ...state,
                allExportSettingsData: { success: false, ...action.error }
            };
        case actionType.CLEAR_SETTINGS_IDS_FOR_NORMAL_RECOM:
            return {
                ...state,
                allExportSettingsData: {}
            };
        case actionType.GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_REQUEST:
            return {
                ...state
            };
        case actionType.GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_SUCCESS:
            return {
                ...state,
                getSourceTemplate: { success: true, data: { ...action.response } }
            };
        case actionType.GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_FAILURE:
            return {
                ...state,
                getSourceTemplate: { success: false, ...action.error }
            };

        case actionType.UPDATE_CORE_REPORT_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_CORE_REPORT_DATA_SUCCESS:
            return {
                ...state,
                updateCoreReportDataResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_CORE_REPORT_DATA_FAILURE:
            return {
                ...state,
                updateCoreReportDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_CA_COLUMNS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_CA_COLUMNS_SUCCESS:
            return {
                ...state,
                caColumns: { success: true, list: action.response }
            };
        case actionType.GET_CA_COLUMNS_FAILURE:
            return {
                ...state,
                caColumns: { success: false, ...action.error }
            };
        case actionType.GET_EXPORT_SETTINGS_ASSET_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORT_SETTINGS_ASSET_SUCCESS:
            return {
                ...state,
                AssetExportSettingsData: { success: true, ...action.response }
            };
        case actionType.GET_EXPORT_SETTINGS_ASSET_FAILURE:
            return {
                ...state,
                AssetExportSettingsData: { success: false, ...action.error }
            };
        case actionType.GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORT_PROPERTY_LIST_ASSET_SUCCESS:
            return {
                ...state,
                exportAssetPropertyList: { success: true, ...action.response }
            };
        case actionType.GET_EXPORT_PROPERTY_LIST_ASSET_FAILURE:
            return {
                ...state,
                exportAssetPropertyList: { success: false, ...action.error }
            };
        case actionType.GET_EXPORT_TEMPLATE_LIST_ASSET_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORT_TEMPLATE_LIST_ASSET_SUCCESS:
            return {
                ...state,
                exportAssetTemplateList: { success: true, ...action.response }
            };
        case actionType.GET_EXPORT_TEMPLATE_LIST_ASSET_FAILURE:
            return {
                ...state,
                exportAssetTemplateList: { success: false, ...action.error }
            };
        case actionType.ADD_EXPORT_SETTINGS_ASSET_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_EXPORT_SETTINGS_ASSET_SUCCESS:
            return {
                ...state,
                saveAssetExportSettingsData: { success: true, ...action.response }
            };
        case actionType.ADD_EXPORT_SETTINGS_ASSET_FAILURE:
            return {
                ...state,
                saveAssetExportSettingsData: { success: false, ...action.error }
            };

        case actionType.GET_TASK_MANAGER_LIST_REQUEST:
            return {
                ...state,
                getTaskManagerResponse: { isLoading: true }
            };
        case actionType.GET_TASK_MANAGER_LIST_SUCCESS:
            return {
                ...state,
                getTaskManagerResponse: { success: true, isLoading: false, ...action.response }
            };
        case actionType.GET_TASK_MANAGER_LIST_FAILURE:
            return {
                ...state,
                getTaskManagerResponse: { success: false, isLoading: false, ...action.error }
            };

        case actionType.GET_SMART_CHART_LOG_REQUEST:
            return {
                ...state,
                getSmartChartLogResponse: { loading: true }
            };

        case actionType.GET_SMART_CHART_LOG_SUCCESS:
            return {
                ...state,
                getSmartChartLogResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_SMART_CHART_LOG_FAILURE:
            return {
                ...state,
                getSmartChartLogResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.DELETE_TASK_MANAGER_BY_ID_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_TASK_MANAGER_BY_ID_SUCCESS:
            return {
                ...state,
                deleteTaskManagerByIdResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_TASK_MANAGER_BY_ID_FAILURE:
            return {
                ...state,
                deleteTaskManagerByIdResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_END_TASK_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_END_TASK_SUCCESS:
            return {
                ...state,
                updateEndTaskManagerResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_END_TASK_FAILURE:
            return {
                ...state,
                updateEndTaskManagerResponse: { success: false, ...action.error }
            };

        case actionType.CLEAR_ALL_TASK_REQUEST:
            return {
                ...state
            };
        case actionType.CLEAR_ALL_TASK_SUCCESS:
            return {
                ...state,
                clearTaskResponse: { success: true, ...action.response }
            };
        case actionType.CLEAR_ALL_TASK_FAILURE:
            return {
                ...state,
                clearTaskResponse: { success: false, ...action.error }
            };

        case actionType.GET_TASK_MANAGER_TABLE_FILTER_REQUEST:
            return {
                ...state,
                taskManagerTableFilterResponse: { loading: true }
            };
        case actionType.GET_TASK_MANAGER_TABLE_FILTER_SUCCESS:
            return {
                ...state,
                taskManagerTableFilterResponse: { loading: false, success: true, list: action.response?.detail }
            };
        case actionType.GET_TASK_MANAGER_TABLE_FILTER_FAILURE:
            return {
                ...state,
                taskManagerTableFilterResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.SET_LAST_VISITED_REPORT:
            return {
                ...state,
                activeLastVisitedReport: {
                    ...state.activeLastVisitedReport,
                    [action.menu]: action.id
                }
            };
        case actionType.GET_BUILDING_TRADES_REQUEST:
            return {
                ...state,
                [action?.key]: { loading: true }
            };
        case actionType.GET_BUILDING_TRADES_SUCCESS:
            return {
                ...state,
                [action?.key]: { loading: false, success: true, list: action.response }
            };
        case actionType.GET_BUILDING_TRADES_FAILURE:
            return {
                ...state,
                [action?.key]: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_ASPOSE_STATUS_REQUEST:
            return {
                ...state,
                getAsposeStatus: { loading: true }
            };
        case actionType.GET_ASPOSE_STATUS_SUCCESS:
            return {
                ...state,
                getAsposeStatus: { loading: false, success: true, data: action.response }
            };
        case actionType.GET_ASPOSE_STATUS_FAILURE:
            return {
                ...state,
                getAsposeStatus: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_DEFAULT_BREAKDOWN_PROPERTY_REQUEST:
            return {
                ...state,
                getDefaultYearBreakdownResponse: { loading: true }
            };
        case actionType.GET_DEFAULT_BREAKDOWN_PROPERTY_SUCCESS:
            return {
                ...state,
                getDefaultYearBreakdownResponse: { loading: false, success: true, data: action.response }
            };
        case actionType.GET_DEFAULT_BREAKDOWN_PROPERTY_FAILURE:
            return {
                ...state,
                getDefaultYearBreakdownResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.PATCH_BREAKDOWN_PROPERTY_REQUEST:
            return {
                ...state,
                patchYearBreakdownProperty: { loading: true }
            };
        case actionType.PATCH_BREAKDOWN_PROPERTY_SUCCESS:
            return {
                ...state,
                patchYearBreakdownProperty: { loading: false, success: true, data: action.response }
            };
        case actionType.PATCH_BREAKDOWN_PROPERTY_FAILURE:
            return {
                ...state,
                patchYearBreakdownProperty: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_PREVIEW_DOC_REQUEST:
            return {
                ...state,
                getDocumentPreviewResponse: { loading: true }
            };
        case actionType.GET_PREVIEW_DOC_SUCCESS:
            return {
                ...state,
                getDocumentPreviewResponse: { loading: false, success: true, data: action.response }
            };
        case actionType.GET_PREVIEW_DOC_FAILURE:
            return {
                ...state,
                getDocumentPreviewResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_DEFAULT_BBI_PROPERTY_REQUEST:
            return {
                ...state,
                getDefaultBbiProperty: { loading: true }
            };
        case actionType.GET_DEFAULT_BBI_PROPERTY_SUCCESS:
            return {
                ...state,
                getDefaultBbiProperty: { loading: false, success: true, data: action.response }
            };
        case actionType.GET_DEFAULT_BBI_PROPERTY_FAILURE:
            return {
                ...state,
                getDefaultBbiProperty: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_DEFAULT_BSI_PROPERTY_REQUEST:
            return {
                ...state,
                getDefaultBsiProperty: { loading: true }
            };
        case actionType.GET_DEFAULT_BSI_PROPERTY_SUCCESS:
            return {
                ...state,
                getDefaultBsiProperty: { loading: false, success: true, data: action.response }
            };
        case actionType.GET_DEFAULT_BSI_PROPERTY_FAILURE:
            return {
                ...state,
                getDefaultBsiProperty: { loading: false, success: false, ...action.error }
            };

        case actionType.UPDATE_USER_DOC_DATA_REQUEST:
            return {
                ...state,
                updateDocForSmartChartResponse: null
            };
        case actionType.UPDATE_USER_DOC_DATA_SUCCESS:
            return {
                ...state,
                updateDocForSmartChartResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_USER_DOC_DATA_FAILURE:
            return {
                ...state,
                updateDocForSmartChartResponse: { success: false, ...action.error }
            };

        case actionType.CREATE_REPORT_FROM_CORE_REPORT_REQUEST:
            return {
                ...state
            };
        case actionType.CREATE_REPORT_FROM_CORE_REPORT_SUCCESS:
            return {
                ...state,
                exportCoreReportDataResponse: { success: true, ...action.response }
            };
        case actionType.CREATE_REPORT_FROM_CORE_REPORT_FAILURE:
            return {
                ...state,
                exportCoreReportDataResponse: { success: false, ...action.error }
            };
        case actionType.CREATE_SKELETON_FROM_TEMPLATE_REQUEST:
            return {
                ...state
            };
        case actionType.CREATE_SKELETON_FROM_TEMPLATE_SUCCESS:
            return {
                ...state,
                coreReportCreateDataResponse: { success: true, ...action.response }
            };
        case actionType.CREATE_SKELETON_FROM_TEMPLATE_FAILURE:
            return {
                ...state,
                coreReportCreateDataResponse: { success: false, ...action.error }
            };
        case actionType.GET_HEADER_KEY_LIST_REQUEST:
            return {
                ...state,
                getHeaderKeyListResponse: { loading: true }
            };
        case actionType.GET_HEADER_KEY_LIST_SUCCESS:
            return {
                ...state,
                getHeaderKeyListResponse: { loading: false, success: true, data: action.response }
            };
        case actionType.GET_HEADER_KEY_LIST_FAILURE:
            return {
                ...state,
                getHeaderKeyListResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_EXECUTIVE_SUMMARY_BAND_TILES_REQUEST:
            return {
                ...state,
                getExecutiveSummaryBandTilesResponse: { loading: true }
            };
        case actionType.GET_EXECUTIVE_SUMMARY_BAND_TILES_SUCCESS:
            return {
                ...state,
                getExecutiveSummaryBandTilesResponse: { loading: false, success: true, data: action.response }
            };
        case actionType.GET_EXECUTIVE_SUMMARY_BAND_TILES_FAILURE:
            return {
                ...state,
                getExecutiveSummaryBandTilesResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_REQUEST:
            return {
                ...state,
                saveExecutiveSummaryTileToBuildingResponse: { loading: true }
            };
        case actionType.SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_SUCCESS:
            return {
                ...state,
                saveExecutiveSummaryTileToBuildingResponse: { loading: false, success: true, data: action.response }
            };
        case actionType.SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_FAILURE:
            return {
                ...state,
                saveExecutiveSummaryTileToBuildingResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.RESET_BUILDING_TRADE_DATA:
            return {
                ...state,
                getBuildingTradeData: {}
            };
        default:
            return state;
    }
};

export default reducers;
